interface SpeakingEvent {
	name: string
	year: number
	location: string
	url: string
}

interface Interview {
	name: string
	location: string
	url: string
	year: number
}

export const speaking: SpeakingEvent[] = [
	// {
	// 	name: '',
	// 	year: 2023,
	// 	location: "WWDC'23 Conference",
	// 	url: '',
	// },
]

export const interviews: Interview[] = [
	// {
	// 	name: '',
	// 	year: 2024,
	// 	location: 'Node.js',
	// 	url: '',
	// },
]
